module.exports = __webpack_public_path__ + "img/cu.6fba565f.png";